module.exports = __webpack_public_path__ + "static/media/bars-solid.1bc10668.png";